<template>
  <div class="wrapper">
    <div v-for="(item,i) in shopImg" :key="i" class="adv-img">
      <a :href="item.url">
        <img :src="item.image_url" alt>
      </a>
      <!-- <a :href="item.val" v-if="item.cat==1">
        <img :src="item.image || item.image_url" alt>
      </a>
      <router-link :to="{name:'help',query: {article_id:item.val}}" v-if="item.cat==2">
        <img :src="item.image  || item.image_url" alt>
      </router-link>
      <router-link :to="{name:'detail',params: {goodsId:item.val}}" v-if="item.cat==3">
        <img :src="item.image  || item.image_url" alt>
      </router-link> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "OneShop",
  components: {},
  props: {
    shopImg: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  watch: {},
  data() {
    return {};
  },
  methods: {}
};
</script>
<style lang="scss" scoped>
.wrapper {
  margin: 30px auto 22px;
  .adv-img {
    width: 100%;
    // height: 120px;
    margin-bottom: 30px;
    img {
      width: 100%;
      height: 100%;
      display: block;
      object-fit: cover;
    }
  }
}
</style>